/* globals setFilterFunctions */
(function () {
	'use strict';

	angular.module('app.core')
		.controller('enterData', enterData);

	enterData.$inject = ['$rootScope', '$scope', '$filter', '$timeout', '$location',
		'leanFilterService', 'leanTableService', 'enterMetricDataService',
		'pageTimingService', 'tableService'];



	function enterData($rootScope, $scope, $filter, $timeout, $location,
			leanFilterService, leanTableService, enterMetricDataService, pageTimingService, tableService) {
		var vm = this;
		var reportConfig = {};
		var extraParams = [{}];
		var reportSettingsName = 'EnterMetricData';
		var extraQueryParams = $location.search();

		vm.metricReminder = extraQueryParams.metricReminder ? extraQueryParams.metricReminder : null;
		vm.dateOfEntry = extraQueryParams.dateOfEntry ? extraQueryParams.dateOfEntry : null;

		$timeout(function () {
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#enterMetricData').addClass('selected');
		}, 0);

		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		$scope.tableService.setReportSettingsName(reportSettingsName);

		vm.formDataHasErrors = false;
		vm.notUpdated = [];
		vm.setTodaysDate = setTodaysDate;
		vm.datePicker = {};
		vm.datePicker.value = vm.metricReminder != null && vm.dateOfEntry !== null ? moment(vm.dateOfEntry).tz('UTC')._d : null;
		vm.datePicker.opened = false;
		vm.hasInvalidDate = !vm.datePicker.value;
		vm.open = function () {
			$timeout(function () {
				vm.datePicker.opened = true;
			});
		};

		// local functions
		vm.calculateValue = calculateValue;
		vm.validateValues = validateValues;
		vm.resetData = resetData;
		vm.submit = submit;
		vm.setDate = setDate;
		vm.dateChanged = dateChanged;
		vm.clearToast = clearToast;
		vm.showCommentEntry = showCommentEntry;
		vm.isEmpty = false;

		var defaultFilters = [
			{'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true},
			{'id': 'metric','values': [leanFilterService.leanDnaAllSelected]},
			{'id': 'valueStream', 'values': [leanFilterService.leanDnaAllSelected]},
			{'id': 'metricFrequency', 'values': [leanFilterService.leanDnaAllSelected]}
		];
		// only show owner filter for admins
		if ( globalConfig.user.profileType.indexOf('Administrator') !== -1
			|| globalConfig.user.canEditAnyMetric ) {
			defaultFilters.push({'id': 'metricOwner','values': [leanFilterService.leanDnaAllSelected]});
		}

		var meta = {
			reportSettingsName: reportSettingsName,
			extraParams: extraParams,
			waitForFilters: true,
			defaultFilters: defaultFilters,
			showExcel: false,
			hideSearch: true,
			reportSettingsScope: 'customer'
		};

		vm.getData = getData;
		vm.getMeta = getMeta;

		function getMeta() {
			return meta;
		}

		function getData() {
			var factoryNdxString = leanFilterService.getFactoryList();
			tableService.trackPageView(reportSettingsName, factoryNdxString);

			enterMetricDataService.getMetricEntries(vm.datePicker.value)
				.then(organizeData);
		}

		function setTodaysDate() {
			vm.datePicker.value = new Date();
			dateChanged();
		}

		function showCommentEntry(metric) {
			metric.showComment = true;
		}

		// preview of result when entering valueA/valueB
		function calculateValue(metric) {
			metric.displayValue = '';
			if (!isBlank(metric.displayValueA) && isNumeric(metric.displayValueA) &&
				!isBlank(metric.displayValueB) && isNumeric(metric.displayValueB) &&
				parseInt(metric.displayValueB) !== 0) {
				metric.displayValue = metric.displayValueA / metric.displayValueB;
				if (metric.displayType === 'percentage') {
					metric.displayValue *= 100;
					metric.displayValue = metric.displayValue.toFixed(2);
				} else {
					metric.displayValue = metric.displayValue.toFixed(3);
				}
				if (metric.displayType === 'percentage') {
					metric.displayValue += '%';
				}
			} else if (!isBlank(metric.displayValueA) || !isBlank(metric.displayValueB)) {
				metric.displayValue = null;
			}
			vm.validateValues(metric);
		}

		function validateValues(metric) {
			if (metric.valueFunction === 'value') {
				if (!isBlank(metric.displayValue) && !isNumeric(metric.displayValue)) {
					metric.valueError = 'Only numeric values are allowed';
				} else {
					metric.valueError = null;
				}
				if (isBlank(metric.displayValue) && !isBlank(metric.displayComment)) {
					metric.commentError = 'You must have a value to have a comment';
				} else {
					metric.commentError = null;
				}
			} else {
				metric.valueAError = null;
				metric.valueBError = null;
				if (!isBlank(metric.displayValueA)) {
					if (!isNumeric(metric.displayValueA)) {
						metric.valueAError = 'Only numeric values are allowed';
					}
					if (isBlank(metric.displayValueB)) {
						metric.valueBError = 'Value B required';
					}
				}
				if (!isBlank(metric.displayValueB)) {
					if (!isNumeric(metric.displayValueB)) {
						metric.valueBError = 'Only numeric values are allowed';
					} else if (parseInt(metric.displayValueB) === 0) {
						metric.valueBError = 'Value B can not be 0';
					}
					if (isBlank(metric.displayValueA)) {
						metric.valueAError = 'Value A required';
					}
				}
				if (isBlank(metric.displayValueA) && isBlank(metric.displayValueB) && !isBlank(metric.displayComment)) {
					metric.commentError = 'You must have a value A or value B to have a comment';
				} else {
					metric.commentError = null;
				}
			}
			// wait for page to update then check for inputs with errors
			$timeout(function () {
				vm.formDataHasErrors = jQuery('input.has-error,input.ng-invalid').length !== 0;
			}, 10);
		}

		function clearToast() {
			vm.toastMessage = undefined;
			vm.errorMessage = undefined;
		}

		function isBlank(value) {
			return value === undefined || value === null || value === '';
		}

		function isNumeric(value) {
			return (/^-?(?:\d+|\d{1,3}(?:,\d+)+)?(?:\.\d+)?$/.test(value));
		}

		function resetData() {
			organizeData(vm.rawData, true);
			for (var i = 0; i < vm.rawData.length; i++) {
				var metric = vm.rawData[i];
				validateValues(metric);
			}
		}

		function setDate(date) {
			vm.datePicker.value = moment(date).add((new Date(date)).getTimezoneOffset(), 'minutes')._d;
		}

		function dateChanged () {
			$timeout(function () {
				vm.formDataHasErrors = jQuery('input.has-error,input.ng-invalid').length !== 0;
			}, 10);

			if (vm.datePicker.value) {
				vm.hasInvalidDate = false;
				vm.notUpdated = [];
				enterMetricDataService.getMetricEntries(vm.datePicker.value)
					.then(organizeData);
			}
		}

		function organizeData(rawData, isReset) {
			if (!isReset) {
				showLimittedMetricsMessage(rawData.actualMetricsCount, rawData.currentMetricsCount);
				rawData = rawData.metrics;
			}
			
			vm.rawData = rawData;
			// this is the structure used for the main model
			var data = {
				'plant': [
					// {
					// 	'baseOwnerNdx': baseOwnerNdx
					// 	'ownerName': ownerName
					// 	'metrics': []
					// }
				],
				'valueStream': [
					// {
					// 	'valueStreamNdx': valueStreamNdx
					// 	'valueStreamName': valuestreamName.
					// 	'ownerName': ownerName
					// 	'metrics': []
					// }
				]
			};

			var previousOwnerNdx = null;
			var previousValueStreamNdx = null;
			var metricGroup = null;
			// incoming data is sorted by:
			// 'Plant'/'ValueStream', valuestream name, owner name, metric name
			if (rawData) {
				for (var i = 0; i < rawData.length; i++) {
					var metric = rawData[i];
					if (metric.resType === 'Plant') {
						// group plant metrics by owner
						if (metric.ownerNdx !== previousOwnerNdx) {
							previousOwnerNdx = metric.ownerNdx;
							metricGroup = {
								'baseOwnerNdx': metric.ownerNdx,
								'ownerName': metric.ownerName,
								'metrics': []
							};
							data.plant.push(metricGroup);
						}
					} else {
						// group valueStream metrics by valueStream
						if (metric.valueStreamNdx !== previousValueStreamNdx) {
							previousValueStreamNdx = metric.valueStreamNdx;
							metricGroup = {
								'valueStreamNdx': metric.valueStreamNdx,
								'valueStreamName': metric.valueStreamName,
								'ownerName': metric.ownerName,
								'metrics': []
							};
							data.valueStream.push(metricGroup);
						}
					}
					metric.displayValue = metric.value;
					metric.displayValueA = metric.valueA;
					metric.displayValueB = metric.valueB;
					metric.displayEnabled = metric.enabled;
					metric.displayComment = metric.comment;
					if (metric.comment && metric.comment.length) {
						metric.showComment = true;
					}

					for (var j = 0; j < metric.otherValuesInPeriod.length; j++) {
						metric.otherValuesInPeriod[j].displayDate =
							$filter('date')(metric.otherValuesInPeriod[j].date, 'shortDate', 'UTC');
					}

					setUpdateFailedStatus(metric);

					metricGroup.metrics.push(metric);
				}
			}
			vm.data = data;
			vm.submissionInProgress = false;
			$timeout(function() {
				pageTimingService.submitUserTiming('Enter Metric Data');
			});
		}

		function setUpdateFailedStatus(metric) {
			for (var i = 0; i < vm.notUpdated.length; i++) {
				var failedMetric = vm.notUpdated[i];
				if (failedMetric.metricNdx === metric.ndx &&
					failedMetric.valueStreamNdx === metric.valueStreamNdx) {
					if (metric.valueFunction === 'value') {
						metric.failedUpdateValues = failedMetric.value;
					} else {
						metric.failedUpdateValues = failedMetric.valueA + ' / ' + failedMetric.valueB;
					}
					break;
				}
			}
		}

		function processResponse(response) {
			vm.notUpdated = response;
			if (vm.notUpdated.length === 0) {
				vm.toastMessage = 'Metrics Updated';
				$timeout(function () {
					vm.toastMessage = '';
				}, 3000);
			} else {
				vm.errorMessage = 'Some metrics failed to update';
				$timeout(function () {
					vm.errorMessage = '';
				}, 5000);
			}
			enterMetricDataService.getMetricEntries(vm.datePicker.value)
				.then(organizeData);
		}

		function submit() {
			vm.submissionInProgress = true;
			// find all the metrics that have changed
			var updatedMetrics = [];
			for (var i = 0; i < vm.rawData.length; i++) {
				var metric = vm.rawData[i];
				var metricChanged = false;
				if (metric.valueFunction === 'value') {
					if (metric.value !== metric.displayValue) {
						metricChanged = true;
						if (!('' + metric.displayValue).trim()) {
							metric.value = null;
						} else {
							// remove commas and calc alternate value fields since they can't be null
							metric.value = metric.displayValue.toString().replace(',', '');
							metric.valueA = metric.value;
							metric.valueB = 1;
						}
					}
				} else if (metric.valueA !== metric.displayValueA ||
					metric.valueB !== metric.displayValueB) {
					metricChanged = true;
					if (!('' + metric.displayValueA).trim()) {
						metric.value = null;
					} else {
						metric.valueA = metric.displayValueA.toString().replace(',', '');
						metric.valueB = metric.displayValueB.toString().replace(',', '');
						metric.value = metric.valueA / metric.valueB;
						if (metric.displayType === 'percentage') {
							metric.value *= 100;
						}
					}
				}
				if (metric.enabled !== metric.displayEnabled) {
					metricChanged = true;
					metric.enabled = metric.displayEnabled;
				}

				if (metric.comment !== metric.displayComment) {
					metricChanged = true;
					metric.comment = metric.displayComment;
				}

				if (metricChanged) {
					var relevantData = {
						factoryNdx: metric.leanDirFactoryNdx,
						metricNdx: metric.ndx,
						valueStreamNdx: metric.valueStreamNdx,
						value: metric.value,
						valueA: metric.valueA,
						valueB: metric.valueB,
						enabled: metric.enabled,
						dateModified: metric.dateModified,
						comment: metric.comment
					};
					if (!metric.enabled) {
						relevantData.periodStart = metric.periodStart;
						relevantData.periodEnd = metric.periodEnd;
					}
					updatedMetrics.push(relevantData);
				}
			}
			enterMetricDataService.updateMetricEntries(
				updatedMetrics,
				vm.datePicker.value)
				.then(processResponse);
		}

		function init() {
			leanFilterService.clearFilters();
			$scope.initialLoad = true;
			$scope.loading = true;
			$scope.filterService.useFactoryFilter = true;
			leanFilterService.useFactoryFilter = true;

			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			siteFilter.sendAllValues = true;

			var filterList = [leanFilterService.filterDefinitions.Metric];
			// only show owner filter for admins
			if ( globalConfig.user.profileType.indexOf('Administrator') !== -1
				|| globalConfig.user.canEditAnyMetric ) {
				filterList.push(leanFilterService.filterDefinitions.MetricOwner);
			}
			filterList = filterList.concat([
				leanFilterService.filterDefinitions.ValueStream,
				leanFilterService.filterDefinitions.MetricFrequency
			]);

			$scope.filterService.setMasterFilterList(filterList);
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
		}

		function showLimittedMetricsMessage(actualMetricsCount, currentMetricsCount) {
			if (actualMetricsCount > currentMetricsCount) {
				$timeout(function () {
					$scope.clearToast();
					var message = 'Showing {0} out of {1} metrics. Please refine your filters.';
					$rootScope.$emit('toast', {
						message: String.format(message, currentMetricsCount, actualMetricsCount),
						success: false
					});
				}, 0);
			}
		}

		init();
	}
})();
